import React from 'react';

import { Box } from '../../Box';
import { Button } from '../../Button';
import { Snackbar } from '../../Snackbar';
import { useIsDesktop } from '../../hooks';

interface PreviewSnackbarProps {
  open: boolean;
  onClick: () => void;
  message: React.ReactNode | React.ReactNode[];
  action: React.ReactNode | React.ReactNode[];
}

/**
 * Компонент Snackbar для предварительного просмотра файла.
 * @param {boolean} open -
 * @param {Function} [onClick] - Опциональная функция, вызываемая при нажатии на кнопку в Snackbar.
 * @param {React.ReactNode | React.ReactNode[]} props.message - Сообщение для отображения в Snackbar.
 * @param {React.ReactNode | React.ReactNode[]} props.action - Действие для отображения в Snackbar (например, кнопка).
 * @returns {ReactElement} Возвращает элемент React с Snackbar для просмотра файла.
 */

export const PreviewSnackbar = ({
  open,
  onClick,
  action,
  message,
}: PreviewSnackbarProps) => {
  const isDesktop = useIsDesktop();

  return (
    <Snackbar
      open={open}
      message={message}
      action={
        <Box display="flex">
          <Button onClick={onClick} size="small" variant="tertiaryDark">
            {action || 'Закрыть'}
          </Button>
        </Box>
      }
      className="aqa_file_preview_snackbar"
      variant={!isDesktop ? 'static' : 'sticky'}
      zPosition="bottom"
    />
  );
};
